import { config } from '../appConfig'
import { GAEvent, GAEventName, GAUserContext } from '../interfaces/googleAnalytics'
import { logger } from '../logger'
import { Attribution, SessionInfo } from './session'

const GA_ENDPOINT = 'https://www.google-analytics.com/mp/collect'
const GA_DEBUG_ENDPOINT = 'https://www.google-analytics.com/debug/mp/collect'

// Get via https://developers.google.com/analytics/devguides/collection/protocol/ga4/sending-events?client_type=gtag#recommended_parameters_for_reports
const MEASUREMENT_ID = config.fetchEnv('GA4_MEASUREMENT_ID')
const API_SECRET = config.fetchEnv('GA4_SECRET')

export class GoogleAnalytics {
  debug: boolean
  clientId: string

  constructor(clientId: string, debug = false) {
    this.debug = debug
    this.clientId = clientId
  }

  async fireEvent(
    name: GAEventName,
    eventData: GAEvent | undefined,
    userContext: GAUserContext | undefined,
    session: SessionInfo,
    attribution: Attribution = {}
  ) {
    const userProperties =
      userContext &&
      Object.fromEntries(Object.entries(userContext).map(([key, value]) => [key, { value }]))

    let url = this.debug ? GA_DEBUG_ENDPOINT : GA_ENDPOINT
    url += `?measurement_id=${MEASUREMENT_ID}&api_secret=${API_SECRET}`

    try {
      const response = await fetch(url, {
        method: 'POST',
        // The popup can be torn down mid-request; keepalive lets the event
        // still reach Google. React Native ignores the unknown option.
        keepalive: true,
        body: JSON.stringify({
          client_id: this.clientId,
          user_properties: userProperties,
          events: [
            {
              name,
              params: {
                session_id: session.sessionId,
                plug_session_number: session.sessionNumber,
                engagement_time_msec: 100,
                ...attribution,
                ...eventData,
              },
            },
          ],
        }),
      })

      if (this.debug) {
        console.log(await response.text())
      }
    } catch (e) {
      logger.error('Google Analytics request failed with an exception', {
        originalError: e,
      })
    }
  }
}
